let routes = [
    {
        path: '/notice/detail',
        name: 'notice-detail',
        meta: {
            title: '详情',
            company: true
        },
        component: () => import('../views/notice/detail')
    }];

export default routes;
